/* global ViewController, WebView */
var forgotPasswordPortalController = new ViewController({
    directory : "views/portal",
    name: "forgotPasswordPortal",
    container: "main",
    route: "portal-forgot-pass",
    openInPopup: true,
    popup: {
        size: "medium"
    }
}) ;

forgotPasswordPortalController.onValidate = function(){
    var login = this.view.getData().login ;
    this.view.longTask(function(done){
        this.api.public.sendPartnerPasswordForgot(login, function(err){
            if(err){ 
                err = this.view.tr("login." + err.error);
                return done(err) ;
            }
            this.view.info(this.view.tr("portal.passwordEmailSent")) ;
            this.view.close() ;
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;


module.exports = forgotPasswordPortalController ;